import React, { useState, useEffect } from 'react';
import { IoCopyOutline, IoCheckmarkOutline } from 'react-icons/io5';
import toast from 'react-hot-toast';
import api from '../services/api';
import { useTranslation } from 'react-i18next';

export default function ReferralContent() {
    const { t } = useTranslation();
    const [referralData, setReferralData] = useState({
        referralCode: '',
        referralLink: ''
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [copiedStates, setCopiedStates] = useState({
        code: false,
        link: false
    });

    useEffect(() => {
        fetchReferralData();
    }, []);

    const fetchReferralData = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await api.getReferenceLink();
            
            if (response.success && response.data) {
                setReferralData({
                    referralCode: response.data.referralCode || '',
                    referralLink: response.data.refferenceLink || ''
                });
            } else {
                throw new Error(response.message || t('referralContent.errorMessage'));
            }
        } catch (err) {
            console.error('Referans bilgileri yüklenirken hata:', err);
            setError(err.message || t('referralContent.errorFetchingData'));
            toast.error(t('referralContent.errorFetchingData'));
        } finally {
            setLoading(false);
        }
    };

    const copyToClipboard = async (text, field) => {
        try {
            await navigator.clipboard.writeText(text);
            const successMessage = field === 'code' ? t('referralContent.codeCopied') : t('referralContent.linkCopied');
            toast.success(successMessage);
            
            // Tik işareti göster
            setCopiedStates(prev => ({
                ...prev,
                [field]: true
            }));
            
            // 3 saniye sonra eski haline döndür
            setTimeout(() => {
                setCopiedStates(prev => ({
                    ...prev,
                    [field]: false
                }));
            }, 3000);
        } catch (err) {
            console.error('Kopyalama hatası:', err);
            toast.error(t('referralContent.copyFailed'));
        }
    };

    if (loading) {
        return (
            <div className="account-content">
                <div className="referral-content">
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                        <p>{t('referralContent.loading')}</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="account-content">
                <div className="referral-content">
                    <div className="error-container">
                        <h3>{t('referralContent.errorTitle')}</h3>
                        <p>{error}</p>
                        <button 
                            className="retry-btn"
                            onClick={fetchReferralData}
                        >
                            {t('referralContent.retryButton')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="account-content">
            <div className="referral-content">
                <div className="referral-header">
                    <h1>{t('referralContent.title')}</h1>
                    <p>{t('referralContent.subtitle')}</p>
                </div>

                <div className="referral-sections">
                    {/* Referans Kodu Bölümü */}
                    <div className="referral-section">
                        <div className="section-label">{t('referralContent.referralCodeLabel')}</div>
                        <div className="code-display">
                            <span className="code-text">{referralData.referralCode}</span>
                            <button 
                                className={`copy-btn ${copiedStates.code ? 'copied' : ''}`}
                                onClick={() => copyToClipboard(referralData.referralCode, 'code')}
                            >
                                {copiedStates.code ? <IoCheckmarkOutline size={16} /> : <IoCopyOutline size={16} />}
                            </button>
                        </div>
                    </div>

                    {/* Referans Linki Bölümü */}
                    <div className="referral-section">
                        <div className="section-label">{t('referralContent.referralLinkLabel')}</div>
                        <div className="link-display">
                            <span className="link-text">{referralData.referralLink}</span>
                            <button 
                                className={`copy-btn ${copiedStates.link ? 'copied' : ''}`}
                                onClick={() => copyToClipboard(referralData.referralLink, 'link')}
                            >
                                {copiedStates.link ? <IoCheckmarkOutline size={16} /> : <IoCopyOutline size={16} />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
